var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"readinglist",class:_vm.background == _vm.Color?'active':''},[_c('p',{on:{"click":_vm.preId}},[_vm._v("上一章")]),_c('p',{on:{"click":_vm.directoryClick}},[_vm._v("目录")]),_c('p',{on:{"click":_vm.nextId}},[_vm._v("下一章")])])
}
var staticRenderFns = []

export { render, staticRenderFns }